import { CS_ROUTES } from './cs.routes';
import { KITCHEN_ROUTES } from './kitchen.routes';
import { LOGISTICS_ROUTES, SECURITY_ROUTES } from './logistics.routes';

export default [...KITCHEN_ROUTES, ...CS_ROUTES, ...LOGISTICS_ROUTES, ...SECURITY_ROUTES];
